import React, { useContext, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  MenuList,
  Select,
  SvgIcon,
  Toolbar,
  Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import styled from '@emotion/styled';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import { AccountCircle } from '@mui/icons-material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { sidebarMenuData } from '../mock/sidebarMenu';
import Copyright from './common/Copyright';
import {
  CONST_SITE_LABEL,
  normalizeRoutePath,
  PLATFORM,
  setScopedItem,
  sidebarIcon,
  STORAGE_KEYS,
  toWholeString,
  USER_ROLE
} from './common/Helper';
import { useAuth } from '../state/AuthContext';
import usePlanAccess from '../hooks/usePlanAccess';
import DebugService from '../services/DebugService';
import './common/Styles.css'
import './common/ModernLayout.css'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CONST_ROUTE_PATH } from '../route/RouteConstants';
import MenuApiService from '../services/MenuApiService';
import SidebarLoader from './common/contentloader/SidebarLoader';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateContext } from '../state/DateContext';
import { useScopedLocalStorage } from '../hooks/useScopedLocalStorage';
import classNames from 'classnames';

/**
 * Padlock shown beside a menu the current plan doesn't include.
 */
const PlanLockIcon = () => (
  <svg
    className='plan-lock-icon'
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

/**
 * Custom Menu List component
 * @param {*} props
 * @returns
 */
export const CustomMenuList = (props) => {
  const [menuData, setMenuData] = useState(props['menuData'] ?? [])
  const [selectedMenu, setSelectedMenu] = useState(props['selectedMenu'] ?? [])
  const [isMenuOpened, setIsMenuOpened] = useState(props['menuOpened'] ?? [])

  return (
    menuData.map((menu, index) => (
      <Accordion key={index} defaultExpanded={menu?.submenu?.length > 0} className='sidebar-menu-accordion' >
        {/* ${menu?.submenu?.length === 0 && 'pointer-events-none'} */}
        <AccordionSummary
          className={`
          sidebar-menu-label 
          ${selectedMenu === menu.id && 'selected-menu'}
          `}
          expandIcon={menu?.submenu?.length > 0 ? <ArrowDropDownIcon /> : ''}
          aria-controls={`panel${index}-content`}
          id={`panel${index}-header`}
          onClick={() => props.handleMenuClick(menu)}
          title={menu.label}
        >
          <img src={`/menu-icons/${menu.icon}-icon.svg`} alt={''} width={20} height={20} />
          {/* <SvgIcon
            color='primary'
            style={{
              width: '16px',

            }}
          >{sidebarIcon(menu.icon)}</SvgIcon> */}
          &nbsp;
          <Typography component='p' style={{
            fontSize: '16px',
            display: isMenuOpened ? '' : 'none'
          }} >{menu.label}</Typography>
        </AccordionSummary>
        <AccordionDetails className='sidebar-submenu-list'>
          <MenuList style={{ padding: '0' }}>
            {menu.submenu && menu.submenu.sort((a, b) => a['order'] - b['order']).map((sbmenu, k) => (
              <MenuItem key={`sb${k}`} style={{
                padding: '0 16px',
              }}
                onClick={() => props.handleMenuClick(sbmenu)}
                className={`
                ${selectedMenu === sbmenu.id && 'selected-sub-menu'}
              `}
                title={sbmenu.label}
              >
                <img src={`/menu-icons/${sbmenu.icon}-icon.svg`} alt={''} width={20} height={20} />
                {/* {sbmenu.path.includes('optimization') || sbmenu.path.includes('inventory') ? (
                  <img src={`/menu-icons/${sbmenu.icon}-icon.svg`} alt={''} width={20} height={20} />
                ) : (
                  <SvgIcon
                    color='primary'
                    style={{
                      width: '13px',

                    }}
                  >{sidebarIcon(sbmenu.icon)}</SvgIcon>
                )} */}
                &nbsp;
                <Typography component='p' style={{
                  fontSize: '14px',
                  display: isMenuOpened ? '' : 'none'
                }} >{sbmenu.label}</Typography>
              </MenuItem>
            ))}
          </MenuList>
        </AccordionDetails>
      </Accordion>
    ))
  )
}

/**
 * Sidebar Menu for Dashboard
 * @param {Object} props - Component props
 * @param {boolean} props.sidebarCollapsed - Whether sidebar is collapsed
 * @returns 
 */
const Sidebar = ({ sidebarCollapsed = false }) => {
  const drawerWidth = 240;
  const navigate = useNavigate()
  const {
    logout,
    userDetails,
    accountList,
    selectedAccount,
    setSelectedAccount,
    selectedPlatform
  } = useAuth();
  const { canAccessPath } = usePlanAccess();

  const [open, setOpen] = React.useState(true);
  const [selectedMenu, setSelectedMenu] = React.useState(null);
  const [pageTitle, setPageTitle] = React.useState('');
  const [menuData, setMenuData] = React.useState(sidebarMenuData);
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDatePicker, setShowDatePicker] = React.useState(false);
  const [expandedMenuIDList, setExpandedMenuIDList] = React.useState([]);
  const [expandedSubMenuIDList, setExpandedSubMenuIDList] = React.useState([]);

  const { selectedDate, setSelectedDate } = useContext(DateContext)
  const location = useLocation()
  const { getScopedItem } = useScopedLocalStorage()

  const handlePageScroll = () => {
    setTimeout(() => {
      const selectedElement = document.querySelector(".selected-sub-menu");

      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  }

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  /**
   * Profile menu click handler
   */
  const handleProfileClick = () => {
    handleMenuClose();
    setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, CONST_ROUTE_PATH.MY_PROFILE)
    navigate(CONST_ROUTE_PATH.MY_PROFILE)
  };

  /**
   * Logout click handler
   */
  const handleLogoutClick = () => {
    handleMenuClose();
    logout()
    setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, CONST_ROUTE_PATH.SIGN_IN)
    navigate(CONST_ROUTE_PATH.SIGN_IN)
  };

  /**
   * Is this menu outside the current plan?
   *
   * Parent menus carry no path of their own, so fall back to their first
   * child's - every child of a group belongs to the same section.
   *
   * @param {*} menu
   * @returns {boolean}
   */
  const isMenuLocked = (menu) => {
    const path = menu?.path || menu?.submenu?.[0]?.path || ''
    return !canAccessPath(normalizeRoutePath(path))
  }

  /**
   * Menu click handler
   * @param {*} menu
   */
  const handleMenuClick = (menu) => {
    if (isMenuLocked(menu)) {
      DebugService.log('Sidebar Component: Menu not included in the current plan', menu?.label)
      return
    }

    if (menu.path !== '' && menu.path !== null) {
      const normalizedPath = normalizeRoutePath(menu.path);
      setSelectedMenu(menu.id)
      setScopedItem(STORAGE_KEYS.CURRENT_ROUTE, normalizedPath)
      navigate(normalizedPath)
    } else {
      DebugService.warn('Sidebar Component: Menu route not available')
    }
  }

  /**
   * Account select handler
   * @param {*} newSelectedAccount 
   */
  const accountSelectHandler = (newSelectedAccount) => {
    if (newSelectedAccount === 'ADD_NEW_ACCOUNT') {
      navigate(CONST_ROUTE_PATH.ADD_ACCOUNT)
    } else {
      setSelectedAccount(newSelectedAccount)
      handlePageScroll()
    }
  }

  /**
   * Fetch the sidebar menu for a specific account + platform.
   *
   * @param {string} account  - the account the request is being made for
   * @param {string} platform - the platform the request is being made for
   * @param {() => boolean} isStale - returns true if the selection changed
   *   while this request was in flight; when stale we drop the response so a
   *   slow AWS response can never overwrite the freshly-selected Azure menu.
   */
  const fetchMenu = (account, platform, isStale) => {
    MenuApiService.get(account, platform).then(data => {
      // A newer account/platform switch happened — this response is stale.
      if (isStale()) return

      DebugService.log('Sidebar Component: Menu Service Response', data)

      if (data !== undefined) {
        let activeMenus = data.map(m => ({
          ...m,
          submenu: m['submenu'].filter(sm => sm['isActive'])
        }))
          .filter(m => m['isActive'] === 1)
          .sort((a, b) => a['order'] - b['order'])


        const storedUserDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(storedUserDetails)

        // Hide "Invoice" submenu for ADMIN and READ ONLY users
        if (Object.keys(parseToJson).length > 0 && [USER_ROLE.ADMIN, USER_ROLE.READ_ONLY].includes(parseToJson['roleName'])) {
          activeMenus = activeMenus.map(m => ({
            ...m,
            submenu: m['submenu'].filter(sm => sm['enum'] !== 'INVOICE')
          }))
          // .filter(m => m['submenu'].length > 0)
        }

        DebugService.log(`Sidebar Component: Menu data for account ${account}`, activeMenus)
        setMenuData(activeMenus)
        setExpandedMenuIDList(activeMenus.map(m => m.id))
        handlePageScroll()

      } else {
        DebugService.error('Sidebar Component: Menu API response is empty', data)
        // Don't leave the previously selected account's menu on screen.
        setMenuData([])
      }
    }).catch(err => {
      if (isStale()) return
      DebugService.error('Sidebar Component: Error while fetching menu', err)
      setMenuData([])
    })
      .finally(() => {
        // Only the latest request is allowed to clear the loading state.
        if (!isStale()) setIsLoading(false)
      })
  }

  /**
   * Menu toggle handler
   * @param {*} action 
   * @param {*} selectedMenuId 
   */
  const toggleHander = (action, selectedMenuId) => {
    console.log(action, selectedMenuId)
    if (action === 'expand') {
      setExpandedMenuIDList([
        ...expandedMenuIDList,
        selectedMenuId
      ])
    } else {
      setExpandedMenuIDList(prev => prev.filter(menuId => menuId !== selectedMenuId))
    }
  }

  /**
   * Submenu toggle handler (for nested submenu under existing submenu)
   * @param {'expand'|'collapse'} action
   * @param {number|string} selectedSubMenuId
   */
  const toggleSubMenuHandler = (action, selectedSubMenuId) => {
    if (action === 'expand') {
      setExpandedSubMenuIDList(prev => [...prev, selectedSubMenuId])
    } else {
      setExpandedSubMenuIDList(prev => prev.filter(id => id !== selectedSubMenuId))
    }
  }

  /**
   * Page load handler
   */
  useEffect(() => {
    // Fetch menus
    setIsLoading(true)

    // if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
    //   fetchMenu()
    // } else {
    //   window.addEventListener('userDetailsEvent', () => {
    //     fetchMenu()
    //   })
    // }
  }, []);

  /**
   * Change page title on url change
   */
  useEffect(() => {
    DebugService.log('Sidebar component: Pathname', window.location.pathname)

    const pathnames = window.location.pathname.split('/')
    if (pathnames.length > 0) {
      const lastPathNameArg = pathnames[pathnames.length - 1]
      if (lastPathNameArg !== '/') {
        setPageTitle(toWholeString(lastPathNameArg))
      }
    }
  }, [navigate])

  useEffect(() => {
    // Set menu selection on menu data load, including nested submenu
    const currentPath = window.location.pathname.toString()
    for (const m of menuData) {
      if (m['submenu'] && m['submenu'].length > 0) {
        for (const sm of m['submenu']) {
          // Direct submenu match
          if (normalizeRoutePath(sm['path']) === currentPath) {
            setSelectedMenu(sm['id'])
            if (!expandedMenuIDList.includes(m.id)) {
              setExpandedMenuIDList(prev => [...prev, m.id])
            }
          }
          // Nested submenu children match
          if (sm['submenu'] && sm['submenu'].length > 0) {
            for (const child of sm['submenu']) {
              if (normalizeRoutePath(child['path']) === currentPath) {
                setSelectedMenu(child['id'])
                if (!expandedMenuIDList.includes(m.id)) {
                  setExpandedMenuIDList(prev => [...prev, m.id])
                }
                if (!expandedSubMenuIDList.includes(sm.id)) {
                  setExpandedSubMenuIDList(prev => [...prev, sm.id])
                }
              }
            }
          }
        }
      } else {
        if (normalizeRoutePath(m['path']) === currentPath) {
          setSelectedMenu(m['id'])
        }
      }
    }
  }, [location.pathname, menuData])

  useEffect(() => {
    setShowDatePicker(prev => location.pathname.includes('dashboard'))
    handlePageScroll()
  }, [location.pathname])

  useEffect(() => {
    // Guard against stale responses: when the account/platform changes again
    // before the in-flight request resolves, this flag marks the old request
    // stale so its response is ignored (prevents Azure showing the AWS menu).
    let stale = false

    // Show the shimmer immediately on every switch so the user never sees the
    // previously selected account's menu while the new one is loading.
    setIsLoading(true)

    const timeout = setTimeout(() => {
      fetchMenu(selectedAccount, selectedPlatform, () => stale)
    }, 300)

    return () => {
      stale = true
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccount, selectedPlatform])

  return (
    <>
      {isLoading ? (
        <SidebarLoader />
      ) : (
        <Grid container className='sidebar-container'>
          {menuData.map((menu, index) => {
          const menuLocked = isMenuLocked(menu)
          return (
            <Grid key={index} item container xs={12}>
              {/* Menu */}
              <Grid item xs={12} className={classNames(
                menu.id === 1 ? 'dashboard-menu-wrapper' : 'menu-wrapper',
                { 'expanded': expandedMenuIDList.includes(menu.id) },
                { 'selected': selectedMenu === menu.id },
                { 'plan-locked': menuLocked }
              )}>
                <Typography component="div" className='menu'>
                  <span
                    className='menu-label'
                    onClick={() => handleMenuClick(menu)}
                    title={menuLocked ? `${menu.label} — upgrade your plan to unlock` : (sidebarCollapsed ? menu.label : '')}
                  >
                    {['Billing'].includes(menu.icon) && selectedPlatform === PLATFORM.AZURE
                      ? <img src={`/menu-icons/Azure${menu.icon}-icon.svg`} alt={menu.label} width={20} height={20} />
                      : <img src={`/menu-icons/${menu.icon}-icon.svg`} alt={menu.label} width={20} height={20} />}
                    {!sidebarCollapsed && (
                      <>
                        &nbsp;{menu.label}
                        {menuLocked && <PlanLockIcon />}
                      </>
                    )}
                  </span>
                  {menu?.submenu?.length > 0 && !sidebarCollapsed && (
                    <>
                      {/* Expanded Icon */}
                      <span className='expanded-icon colored-collapse-icon' onClick={() => toggleHander('collapse', menu.id)}>
                        <img src='/accordion-expand-icon.svg' alt='Expanded Menu' width={'13px'} height={'13px'} />
                      </span>

                      {/* Collapsed Icon */}
                      <span className='collapsed-icon colored-collapse-icon' onClick={() => toggleHander('expand', menu.id)}>
                        <img src='/accordion-collapse-icon.svg' alt='Collapsed Menu' width={'13px'} height={'13px'} />
                      </span>
                    </>
                  )}
                </Typography>
              </Grid>

              {/* Sub-Menu */}
              {menu?.submenu?.length > 0 && expandedMenuIDList.includes(menu.id) && !sidebarCollapsed && (
                <Grid item xs={12} className='sub-menu-wrapper'>
                  {menu.submenu.sort((a, b) => a['order'] - b['order']).map((sbmenu, k) => {
                    const subMenuLocked = isMenuLocked(sbmenu)
                    return (
                    <div key={`sb${k}`} className={classNames('sub-menu-item', { 'has-children': sbmenu?.submenu?.length > 0, 'open': expandedSubMenuIDList.includes(sbmenu.id) })}>
                      <div className={classNames('sub-menu-row', { 'selected': selectedMenu === sbmenu.id, 'plan-locked': subMenuLocked })}>
                        <Typography
                          variant="button"
                          className={classNames('sub-menu', { 'selected': selectedMenu === sbmenu.id, 'selected-sub-menu': selectedMenu === sbmenu.id })}
                          onClick={() => handleMenuClick(sbmenu)}
                          title={subMenuLocked ? `${sbmenu.label} — upgrade your plan to unlock` : sbmenu.label}
                        >
                          {['CloudConsole', 'CostExplorer', 'DataTransfer'].includes(sbmenu.icon) && selectedPlatform === PLATFORM.AZURE
                            ? <img src={`/menu-icons/Azure${sbmenu.icon}-icon.svg`} alt={sbmenu.label} width={20} height={20} />
                            : <img src={`/menu-icons/${sbmenu.icon}-icon.svg`} alt={sbmenu.label} width={20} height={20} />}
                          &nbsp;{sbmenu.label}
                          {subMenuLocked && <PlanLockIcon />}
                        </Typography>

                        {sbmenu?.submenu?.length > 0 && (
                          <div className='sub-menu-actions'>
                            {/* Expanded Icon for Submenu */}
                            {expandedSubMenuIDList.includes(sbmenu.id) &&
                              (
                                <span
                                  className='expanded-icon colored-collapse-icon'
                                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSubMenuHandler('collapse', sbmenu.id) }}
                                >
                                  <img src='/accordion-expand-icon.svg' alt='Expanded Submenu' width={'12px'} height={'12px'} />
                                </span>)
                            }
                            {/* Collapsed Icon for Submenu */}
                            {!expandedSubMenuIDList.includes(sbmenu.id) &&
                              <span
                                className='collapsed-icon colored-collapse-icon'
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSubMenuHandler('expand', sbmenu.id) }}
                              >
                                <img src='/accordion-collapse-icon.svg' alt='Collapsed Submenu' width={'12px'} height={'12px'} />
                              </span>
                            }
                          </div>
                        )}
                      </div>

                      {/* Nested Sub-Menu List */}
                      {sbmenu?.submenu?.length > 0 && expandedSubMenuIDList.includes(sbmenu.id) && (
                        <div className='sub-sub-menu-wrapper'>
                          {sbmenu.submenu.sort((a, b) => (a['order'] ?? 0) - (b['order'] ?? 0)).map((child, ck) => {
                            const childLocked = isMenuLocked(child)
                            return (
                            <Typography
                              key={`sbchild${ck}`}
                              variant="button"
                              className={classNames('sub-sub-menu', { 'selected': selectedMenu === child.id, 'selected-sub-menu': selectedMenu === child.id, 'plan-locked': childLocked })}
                              onClick={() => handleMenuClick(child)}
                              title={childLocked ? `${child.label} \u2014 upgrade your plan to unlock` : child.label}
                            >
                              {child?.icon ? (
                                ['CloudConsole', 'CostExplorer', 'DataTransfer'].includes(child.icon) && selectedPlatform === PLATFORM.AZURE
                                  ? <img src={`/menu-icons/Azure${child.icon}-icon.svg`} alt={child.label} width={18} height={18} />
                                  : <img src={`/menu-icons/${child.icon}-icon.svg`} alt={child.label} width={18} height={18} />
                              ) : null}
                              {child?.icon && '\u00A0'}{child.label}
                              {childLocked && <PlanLockIcon />}
                            </Typography>
                            )
                          })}
                        </div>
                      )}
                    </div>
                    )
                  })}
                </Grid>
              )}
            </Grid>
          )
          })}
        </Grid>
      )}

      {/* Top toolbar */}
      <AppBar position="absolute" open={open} style={{
        backgroundColor: '#2b2e63',
        display: 'none'
      }}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <Link title='Home' to="/" className='home-logo' style={{
            margin: '10px',
            display: !open ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <img src={`/${CONST_SITE_LABEL}-short-logo.png`} alt={CONST_SITE_LABEL} style={{
              width: '30px'
            }} />
          </Link>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            style={{
              // flexGrow: 1,
              // maxWidth: '10vw'
              marginRight: '3vw'
            }}
          >
            {(location.pathname.includes('optimization') || location.pathname.includes('inventory')) && 'AWS '}
            {pageTitle.toLocaleUpperCase()}
          </Typography>

          {showDatePicker && <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                value={selectedDate}
                onChange={(v) => setSelectedDate(v)}
                className='sidebar-datepicker'
                disableFuture
                slotProps={{
                  textField: {
                    size: 'small',
                    required: false,
                    readOnly: true
                  }
                }}
                title="Select date"
              />
            </DemoContainer>
          </LocalizationProvider>
          }

          {/* Project select box */}
          {!location.pathname.includes('add-account') && (
            <FormControl size="small" sx={{
              minWidth: 120,
              margin: '10px 0 0 10px',
              "& .MuiInputBase-input": { color: "#fff" },  // Text color inside Select
              "& .MuiSvgIcon-root": { color: "#40E0D0" },    // Dropdown arrow color
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#40E0D0" }  // Border color
            }}>
              <InputLabel id="demo-simple-select-standard-label" style={{ color: '#40E0D0' }}>Account</InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                // value={age}
                onChange={(e) => accountSelectHandler(e['target']['value'])}
                label="Account"
                style={{ color: '#fff' }}
                value={selectedAccount}
              >
                {accountList && accountList.length > 0 && accountList.map(a => (
                  <MenuItem key={a['accountId']} value={a['accountId']}>{a['accountId']}-{a['accountAliase']}</MenuItem>
                ))}
                <MenuItem key={'add-account'} value={'ADD_NEW_ACCOUNT'}>Add Account</MenuItem>
              </Select>
            </FormControl>
          )}

          {/* <NestedDropdown /> */}

          <div style={{ marginLeft: 'auto' }}>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-controls="user-menu"
              aria-haspopup="true"
              onClick={($event) => handleMenuOpen($event)}
            >
              <AccountCircle />
              <Typography color={'#fff'}>{userDetails['firstname'] ?? ''}</Typography>

            </IconButton>
            <Menu
              className='account-menu'
              id="user-menu"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              // keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={handleProfileClick}
                sx={{
                  fontSize: '1vw',
                  ":hover": {
                    backgroundColor: '#57adbf'
                  }
                }}
              >My Profile</MenuItem>
              <MenuItem
                onClick={handleLogoutClick}
                sx={{
                  fontSize: '1vw',
                  ":hover": {
                    backgroundColor: '#57adbf'
                  }
                }}
              >Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Drawer variant="permanent" open={open} style={{
        height: '100vh',
        display: 'none'
      }}>

        {/* Toggle Icon */}
        <Toolbar
          style={{
            // background: 'linear-gradient(to top right, #57adbf , #2b2e63)',
            // backgroundColor: '#2b2e63',
            // borderColor: '#2b2e63',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: [1]
          }}
        >
          {/* Display logo */}
          <Link title='Home' to="/" className='home-logo'>
            <img src={`/${CONST_SITE_LABEL}-logo.png`} alt={CONST_SITE_LABEL} style={{
              width: '100px'
            }} />
          </Link>

          {/* Display menu collapse icon */}
          <IconButton onClick={toggleDrawer} color='primary'>
            <ChevronLeftIcon style={{
              // color: '#fff'
            }} />
          </IconButton>
        </Toolbar>

        <Divider />

        {isLoading ? (
          <SidebarLoader />
        ) : (
          <CustomMenuList
            menuOpened={open}
            menuData={menuData}
            selectedMenu={selectedMenu}
            handleMenuClick={handleMenuClick}
          />
        )}

        {/* Copyright */}
        <Copyright style={{
          marginTop: '1vw'
        }} />
      </Drawer>
    </>
  )
};

export default Sidebar;
